import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepThreeCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepThreeCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.findWordsStepThreeCollections.data.findWordsStepThreeCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.findWordsStepThreeCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
